import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const WebSiteAdTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={10} />
		</Box>
	);
};

export default WebSiteAdTable;
